import { __awaiter } from "tslib";
import { LocalStorage } from "node-localstorage";
export default class LocalStorageAdapter {
    constructor() {
        var _a;
        this.localStorage =
            ((_a = globalThis.window) === null || _a === void 0 ? void 0 : _a.localStorage) || new LocalStorage("./scratch");
    }
    has(contentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.localStorage.getItem(contentId) !== null;
        });
    }
    // REASON: eslint does not understand inheritance
    // eslint-disable-next-line class-methods-use-this
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            // NOP
        });
    }
    set(contentId, content) {
        return __awaiter(this, void 0, void 0, function* () {
            this.localStorage.setItem(contentId, content);
            return contentId;
        });
    }
    get(contentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.localStorage.getItem(contentId);
        });
    }
    remove(contentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.localStorage.removeItem(contentId);
        });
    }
}
